import { useContext, useMemo } from 'react'

import { isFunction } from 'lodash'

import { getStudentFullSection } from '../../../../utils/entities/student'
import { SearchStudentFormModalContext } from '../../../../Providers/Forms/StudentForm/SearchStudentModalProvider'
import EntitiesSelector from '../EntitiesSelector'

const StudentsSelector = ({ disabled, loading, multiple = 'default', notFoundContent, placeholder, style = {}, students = [], tagPlaceholder, values, dropdownRender = null, showSearch, onChange, onSearch, onPopupScroll }) => {
  const context = useContext(SearchStudentFormModalContext)

  const options = useMemo(() => students.map(student => ({
    label: `${student.lastname} ${student.firstname} - ${getStudentFullSection(student)}`,
    value: student.id,
    tooltip: `${student.lastname} ${student.firstname} - ${getStudentFullSection(student)}`,
    entity: student
  })), [students])

  return (
    <EntitiesSelector
      disabled={disabled}
      dropdownMatchSelectWidth={false}
      entityOptions={options}
      loading={loading}
      multiple={multiple}
      placeholder={placeholder}
      showSearch={showSearch}
      style={style}
      tagPlaceholder={tagPlaceholder}
      values={values}
      dropdownRender={context !== undefined && isFunction(dropdownRender) ? dropdownRender(context.setFormHandler) : dropdownRender}
      notFoundContent={notFoundContent}
      onChange={onChange}
      onSearch={onSearch}
      onPopupScroll={onPopupScroll}
    />
  )
}

export default StudentsSelector
